import React from 'react'

const Choose = () => {
  return (
    <section className='flex bg-white mx-50'>
      <div className='justify-center w-full aglign-center bg-slate-100 h-80 '>
      <div className='flex justify-center aglign-center  list-none'>
        <li className='items-center mt-10 text-center'>
    <p className='flex-row'>
            Why Choose SlyBuild
            </p>
            <h1 className='text-2xl font-bold mt30'>
            Our Soluti ons Cover a Wide Range of Industries
            </h1>
            </li>
    </div>

    <div className='flex justify-center items-center '>
        <ul className='text-center m-6'>
            <li className='mt-5'>
            Expert Team: Our experts bring years of industry knowledge to help solve complex challenges.
            </li>
            <li className='mt-5'>
            Proven Success: Trusted by leading businesses across the globe.
            </li>
            <li className='mt-5'>
            Cost-Effective Solutions: Achieve more while optimizing your budget.
            </li>
        </ul>
    </div>

    </div>

   

    
    
    </section>
  )
}

export default Choose
